import React from 'react';
import './ProgressBar.scss';

const ProgressBar = ({ currentPage }) => {
  return (
    <div className="progress-bar-container">
      <div className="progress-steps">
        {/* Step 1 */}
        <div className="step-container">
          <div
            className={`step-circle ${currentPage === 1 ? 'active' : ''} ${
              currentPage > 1 ? 'completed' : ''
            }`}
          >
            {currentPage > 1 ? (
              <span className="checkmark">
                 <svg 
                style={{
                  marginTop: '12px',
                  marginLeft: '7px'
                }}
                width="64" 
                height="64" 
                viewBox="0 0 32 32" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
            >
                <path 
                  d="M10 14L7 11L5.5 12.5L10 17L20 7L18.5 5.5L10 14Z" 
                    fill="rgba(0, 0, 0, 0.4)"
                />
                </svg>    
              </span>
            ) : (
              "1"
            )}
          </div>
          <span
            className={`step-label ${
              currentPage === 1 ? 'active' : ''
            } ${currentPage > 1 ? 'completed' : ''}`}
          >
            SELECT PACKAGES
          </span>
        </div>

        {/* Line connecting the steps */}
        <div className="progress-line"></div>

        {/* Step 2 */}
        <div className="step-container">
          <div className={`step-circle ${currentPage >= 2 ? 'active' : ''}`}>
            2
          </div>
          <span className={`step-label ${currentPage >= 2 ? 'active' : ''}`}>
            DEALER INFORMATION
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;